import { create } from 'zustand';

// The one message the setup checklist's live region is currently saying. A store, not card
// state: the region is hoisted out of the card, which `Hide` unmounts — and a region removed
// in the same commit as its message announces nothing.
type ChecklistAnnouncerStore = {
  message: string;
  /** Bumped per announcement: an unchanged string is a no-op, so a repeat would never be read. */
  nonce: number;
  announce: (message: string) => void;
};

const useChecklistAnnouncerStore = create<ChecklistAnnouncerStore>((set) => ({
  message: '',
  nonce: 0,
  announce: (message) => set((state) => ({ message, nonce: state.nonce + 1 })),
}));

export default useChecklistAnnouncerStore;
